import {
  firmCompGroupsUrl,
  firmScimConfigurationUrl,
  firmSettingsUrl,
  firmSingleSignOnUrl,
  firmSummaryUrl,
  firmUserManagementUrl,
  firmWaterfallUrl,
} from 'common/config/urls';
import {
  FIRM_SETTINGS_SLUG,
  SCIM_CONFIGURATION_PAGE_TITLE,
  SCIM_CONFIGURATION_TAB,
  SINGLE_SIGN_ON_PAGE_TITLE,
  SINGLE_SIGN_ON_TAB,
} from 'common/constants/firms';
import {
  FIRM_WATERFALL,
  FIRM_WATERFALL_PAGE_TITLE,
  USER_MANAGEMENT_PAGE_TITLE,
  USER_MANAGEMENT_TAB,
} from 'common/constants/user';
import { FIRM_NAVIGATION_IDS } from './firmNavigation.constants';
import type { FirmNavigationRoute } from './firmNavigation.types';

export const FIRM_NAVIGATION_ROUTES: FirmNavigationRoute[] = [
  {
    id: FIRM_NAVIGATION_IDS.SUMMARY,
    route: firmSummaryUrl,
    hidden: false,
    slug: 'summary',
    title: 'Summary',
    itemKey: 0,
  },
  {
    id: FIRM_NAVIGATION_IDS.SETTINGS,
    route: firmSettingsUrl,
    hidden: false,
    slug: FIRM_SETTINGS_SLUG,
    title: 'Settings',
    itemKey: 1,
  },
  {
    id: FIRM_NAVIGATION_IDS.COMP_GROUPS,
    route: firmCompGroupsUrl,
    hidden: false,
    slug: 'comp-groups',
    title: 'Comp Groups',
    itemKey: 2,
  },
  {
    id: FIRM_NAVIGATION_IDS.USER_MANAGEMENT,
    route: firmUserManagementUrl,
    hidden: false,
    slug: USER_MANAGEMENT_TAB,
    title: USER_MANAGEMENT_PAGE_TITLE,
    itemKey: 3,
  },
  {
    id: FIRM_NAVIGATION_IDS.WATERFALL,
    route: firmWaterfallUrl,
    hidden: false,
    slug: FIRM_WATERFALL,
    title: FIRM_WATERFALL_PAGE_TITLE,
    itemKey: 5,
  },
  {
    id: FIRM_NAVIGATION_IDS.SINGLE_SIGN_ON,
    route: firmSingleSignOnUrl,
    hidden: false,
    slug: SINGLE_SIGN_ON_TAB,
    title: SINGLE_SIGN_ON_PAGE_TITLE,
    itemKey: 6,
  },
  {
    id: FIRM_NAVIGATION_IDS.SCIM_CONFIGURATION,
    route: firmScimConfigurationUrl,
    hidden: false,
    slug: SCIM_CONFIGURATION_TAB,
    title: SCIM_CONFIGURATION_PAGE_TITLE,
    itemKey: 7,
  },
];

export type { FirmNavigationRouteBuilder } from './firmNavigation.types';
